import axios from "./axiosinstance";


const ProjectApi = {

  create: (payload) =>
    axios.post(
      "/projects/create",
      payload
    ),


  myProjects: () =>
    axios.get(
      "/projects/my-projects"
    ),


  list: (params) =>
    axios.get(
      "/projects/list",
      {
        params,
      }
    ),


  details: (id) =>
    axios.get(
      `/projects/${id}`
    ),


  updateStatus: (
    id,
    payload
  ) =>
    axios.put(
      `/projects/update-status/${id}`,
      payload
    ),


  assignDeveloper: (
    id,
    payload
  ) =>
    axios.put(
      `/projects/assign-developer/${id}`,
      payload
    ),


  assignTester: (
    id,
    payload
  ) =>
    axios.put(
      `/projects/assign-tester/${id}`,
      payload
    ),


  readyForTesting: (id) =>
    axios.put(
      `/projects/ready-for-testing/${id}`
    ),


  updateTestingCredentials: (
    id,
    payload
  ) =>
    axios.put(
      `/projects/testing-credentials/${id}`,
      payload
    ),


  handoverToTesting: (
    id,
    payload
  ) =>
    axios.put(
      `/projects/handover-testing/${id}`,
      payload
    ),


  assignedTestingProjects: () =>
    axios.get(
      "/projects/assigned-testing"
    ),


  startTesting: (id) =>
    axios.put(
      `/projects/start-testing/${id}`
    ),


  approveTesting: (id) =>
    axios.put(
      `/projects/approve-testing/${id}`
    ),

};


export default ProjectApi;